import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { applyTheme, getTheme } from "./util/theme";
// UI font — variable Inter (Latin, Latin-Ext w/ Uzbek okina, Cyrillic for RU).
import "@fontsource-variable/inter/index.css";
// Instrument/data font — mono numerals & activation codes.
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/700.css";
import "./styles.css";

applyTheme(getTheme());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
